var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1736240675212,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 29008,
    width: 32,
    height: 32,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M848 499.84v113.92l2.56 7.04 110.08 273.92H631.04l109.44-270.08 2.56-6.4v-7.68l0.64-99.2V499.84h104.32",
    opacity: 0.4,
    "p-id": 29009,
    fill: "#46766a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M567.68 816H72.32c-39.68 0-72.32-32.64-72.32-72.32V164.48c0-39.68 32.64-72.32 72.32-72.32h880c39.68 0 72.32 32.64 72.32 72.32v579.2c0 10.24-8.32 18.56-18.56 18.56-10.24 0-18.56-8.32-18.56-18.56V164.48c0-19.2-16-35.2-35.2-35.2H72.32c-19.2 0-35.2 16-35.2 35.2v579.2c0 19.2 16 35.2 35.2 35.2h495.36c10.24 0 18.56 8.32 18.56 18.56 0 10.24-8.32 18.56-18.56 18.56zM19.84 911.36h515.2M535.04 929.92H19.84c-10.24 0-18.56-8.32-18.56-18.56 0-10.24 8.32-18.56 18.56-18.56h515.2c10.24 0 18.56 8.32 18.56 18.56 0 10.24-8.32 18.56-18.56 18.56zM487.04 232.96h419.84",
    "p-id": 29010,
    fill: "#46766a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M906.88 251.52H487.04c-10.24 0-18.56-8.32-18.56-18.56s8.32-18.56 18.56-18.56h419.2c10.24 0 18.56 8.32 18.56 18.56s-7.68 18.56-17.92 18.56zM487.04 333.44h259.2M746.24 351.36H487.04c-10.24 0-18.56-8.32-18.56-18.56s8.32-18.56 18.56-18.56h259.2c10.24 0 18.56 8.32 18.56 18.56s-8.32 18.56-18.56 18.56zM709.12 666.24h55.68M764.8 684.8h-55.68c-10.24 0-18.56-8.32-18.56-18.56 0-10.24 8.32-18.56 18.56-18.56h55.68c10.24 0 18.56 8.32 18.56 18.56 0 10.24-8.32 18.56-18.56 18.56z",
    "p-id": 29011,
    fill: "#46766a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M678.4 752.64h98.56M776.96 771.2H678.4c-10.24 0-18.56-8.32-18.56-18.56 0-10.24 8.32-18.56 18.56-18.56h98.56c10.24 0 18.56 8.32 18.56 18.56 0 10.24-8.32 18.56-18.56 18.56z",
    "p-id": 29012,
    fill: "#46766a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M289.92 622.72c-92.8 0-168.96-75.52-168.96-168.96s75.52-168.96 168.96-168.96S458.88 360.96 458.88 454.4 382.72 622.72 289.92 622.72z m0-300.16C217.6 322.56 158.08 381.44 158.08 454.4S217.6 586.24 289.92 586.24 421.76 526.72 421.76 454.4s-59.52-131.84-131.84-131.84z",
    "p-id": 29013,
    fill: "#46766a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M263.04 531.2l-60.8-60.8c-7.04-7.04-7.04-19.2 0-26.24 7.04-7.04 19.2-7.04 26.24 0l34.56 34.56L351.36 390.4c7.04-7.04 19.2-7.04 26.24 0 7.04 7.04 7.04 19.2 0 26.24L263.04 531.2zM848 499.84V614.4l2.56 6.4 110.08 273.92H631.04l109.44-270.08 2.56-6.4v-7.04l0.64-99.2v-12.16h104.32m68.48-37.12h-241.28v39.68h31.36v8.96l-0.64 99.2-118.4 292.48c-1.28 2.56-1.92 5.76-1.92 8.32 0 10.88 7.68 19.84 16.64 19.84h385.92c2.56 0 5.12-0.64 7.04-1.92 8.32-4.48 12.16-16.64 7.68-26.88l-119.04-296.32V501.76h31.36v-39.04h1.28z",
    "p-id": 29014,
    fill: "#46766a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/检验检查.297905b7bf6e0c0b453ce183e77defda.svg";
export { ForwardRef as ReactComponent };